import { Button } from '@cloudflare/kumo';
import { useMutation, useQuery } from '@tanstack/react-query';
import { createRoute } from '@tanstack/react-router';
import { api, queryClient, unwrap } from '../api.ts';
import { ErrorNotice, Loading } from '../common.tsx';
import { Route as parent } from './signed-in.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/connections',
  component: AgentConnectionsPage,
});

function AgentConnectionsPage() {
  const connections = useQuery({
    queryKey: ['agent-connections'],
    queryFn: async () => unwrap(await api.GET('/api/agent-connections')),
  });
  const disconnect = useMutation({
    mutationFn: async (connectionId: string) =>
      unwrap(
        await api.POST('/api/agent-connections/{connectionId}/disconnect', {
          params: { path: { connectionId } },
          body: {},
        }),
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['agent-connections'] }),
  });
  return (
    <main className="mx-auto my-12 p-6 max-w-168 [&_p]:mx-0 [&_p]:my-4 [&_p]:leading-[1.65] [&_.checkbox-row]:mx-0 [&_.checkbox-row]:my-5 [&_.action-row]:mt-6 [&_.action-row]:flex-wrap">
      <h1 className="text-[30px] leading-[1.2] font-semibold tracking-[-0.8px]">Connected agents</h1>
      <p className="leading-[1.65]">
        Connect ChatGPT, Claude, or another MCP client using this server address:
      </p>
      <code className="p-4 border border-kumo-line block rounded-[0.75rem] wrap-anywhere">
        {location.origin}/mcp
      </code>
      <p className="leading-[1.65]">
        Agents use your current permissions. Disconnecting one leaves your browser session and other agents
        signed in.
      </p>
      <ErrorNotice error={connections.error ?? disconnect.error} />
      {connections.isPending ? (
        <Loading />
      ) : connections.data?.length ? (
        <ul className="p-0 list-none [&_li]:px-0 [&_li]:py-4 [&_li]:border-t [&_li]:border-t-kumo-line [&_li]:flex [&_li]:items-start [&_li]:justify-between [&_li]:gap-4 [&_li_>_div:first-child]:grid [&_li_>_div:first-child]:gap-1 [&_li_>_div:first-child]:wrap-anywhere [&_li_>_div:first-child]:min-w-0 [&_li_span]:text-kumo-subtle [&_li_span]:text-[0.875rem] min-[601px]:[&_li]:items-center">
          {connections.data.map((connection) => (
            <li key={connection.id}>
              <div>
                <strong>{connection.name}</strong>
                <span>Connected {new Date(connection.createdAt).toLocaleDateString()}</span>
              </div>
              <Button
                disabled={disconnect.isPending}
                aria-label={`Disconnect ${connection.name}`}
                onClick={() => disconnect.mutate(connection.id)}
              >
                Disconnect
              </Button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="leading-[1.65]">No external agents are connected.</p>
      )}
    </main>
  );
}
